<div class="container {{ getContainerClass() }}">
  <button
    #button
    class="accordion {{ getAccordionClass() }}"
    (click)="onToggle()"
    [style.width]="buttonWidth"
  >
    <div>{{ title }}</div>
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.577574 0.744078C0.903011 0.418641 1.43065 0.418641 1.75609 0.744078L7.00016 5.98816L12.2442 0.744078C12.5697 0.418641 13.0973 0.418641 13.4228 0.744078C13.7482 1.06951 13.7482 1.59715 13.4228 1.92259L7.58942 7.75592C7.26398 8.08136 6.73634 8.08136 6.41091 7.75592L0.577574 1.92259C0.252137 1.59715 0.252137 1.06951 0.577574 0.744078Z"
        fill="#4D5154"
      />
    </svg>
  </button>
  <div
    #panel
    class="panel {{ getPanelClass() }}"
    [style.max-height]="getPanelHeight()"
    [style.left]="panelLeft()"
    [style.width]="contentWidth"
  >
    <ng-content></ng-content>
  </div>
</div>
